import BillingPricingComponent from "./component"

class BillingPricingSlider extends BillingPricingComponent {
  static init(...args) {
    return super.init(...args)[0]
  }

  static get selector() {
    return "[data-billing-pricing-slider]"
  }

  init() {
    this.pageLimit = this.element.value
    // Only one slider in a pricing, it's always selected.
    this.selected = true

    this.element.addEventListener("change", (e) => {
      this.pageLimit = e.detail.value

      this.pricing.pageLimitChanged()
    })

    this.initialized()
  }

  valid() {
    return super.valid() && this.pageLimit
  }
}

export default BillingPricingSlider
